module.exports = __webpack_public_path__ + "img/22.e1313b0c.jpg";